/* eslint-disable react-hooks/exhaustive-deps */
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Modal, Search, MyButton } from "../../../component/Component";
import { addOneRegion } from "../../../../../middlewares/breadCrumb/BreadCrumb";
import { BreadCrumbComponent } from "../../../../../middlewares/breadCrumb/BreadCrumbComponent";
import { useContinentRegionContext } from "../../../../../context/continentRegion/context/ContinentRegionContext";
import {
  pushRegion,
  pushCurrentRegion,
} from "../../../../../middlewares/sysNavigation/SysNavigation";

const addRoute = "/region/add";
const editRegionRoute = "/region/edit";
const singleRegionDash = "/region/dashboard";
const regionCountries = "/countries";

/** Reusable, generic confirmation modal (UI-only; doesn’t modify your logic) */
const ConfirmDialog = ({
  open,
  title,
  message,
  confirmText = "Continue",
  cancelText = "Cancel",
  onConfirm,
  onClose,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/30"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-sm rounded-2xl bg-white p-5 shadow-2xl">
        <h3 className="text-sm font-semibold text-gray-900">{title}</h3>
        <p className="mt-2 text-xs text-gray-600">{message}</p>
        <div className="mt-4 flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-300"
          >
            {cancelText}
          </button>
          <button
            type="button"
            onClick={() => {
              onConfirm?.();
              onClose?.();
            }}
            className="inline-flex items-center rounded-lg bg-gray-900 px-3 py-1.5 text-xs font-semibold text-white hover:bg-gray-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-gray-900"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

const Overview = () => {
  const [regionsList, setRegionsList] = useState([]);
  const { regions, fetchRegions } = useContinentRegionContext();

  useEffect(() => {
    if (!regions) fetchRegions();
    else setRegionsList(regions);
  }, [regions]);

  const SearchList = (e) => {
    const key = String(e.target.value).toLowerCase();
    if (!key) {
      setRegionsList(regions || []);
      return;
    }
    const searchArray = [];
    regions?.forEach((region) => {
      if (String(region?.name).toLowerCase().includes(key)) {
        searchArray.push(region);
      }
    });
    setRegionsList(searchArray);
  };

  return (
    <div className="p-3 lg:p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <BreadCrumbComponent default_value={true} />

      {/* Header card */}
      <div className="mb-4 rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="text-sm font-semibold text-gray-900">
              Regions Overview
            </h2>
            <p className="mt-1 text-[11px] text-gray-600">
              Search, review, and manage Africa’s regions. Use the quick actions
              to drill into dashboards, countries, and editing.
            </p>
          </div>
          <div className="flex items-center gap-2">
            <Link to={addRoute}>
              <MyButton className="bg-gray-900 hover:bg-gray-800 rounded-lg">
                + Add Region
              </MyButton>
            </Link>
          </div>
        </div>
      </div>

      {/* Search */}
      <div className="mb-3">
        <Search
          props={{
            title: "Region",
            onChange: (e) => SearchList(e),
          }}
        />
      </div>

      {/* Table */}
      <div className="rounded-2xl border border-gray-200 bg-white p-2 shadow-sm">
        <div className="w-full overflow-x-auto">
          <table className="w-full table-auto border-collapse text-xs">
            <thead className="bg-gray-50 text-gray-900 sticky top-0">
              <tr>
                <th className="px-3 py-3 text-left font-semibold">Name</th>
                <th className="px-3 py-3 text-left font-semibold">Slug</th>
                <th className="px-3 py-3 text-left font-semibold">
                  No. of Countries
                </th>
                <th className="px-3 py-3 text-center font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {regions ? (
                regionsList?.map((region, key) => (
                  <tr key={key} className="hover:bg-gray-50">
                    <td className="px-3 py-3">{region?.name}</td>
                    <td className="px-3 py-3">{region?.slug}</td>
                    <td className="px-3 py-3">{region?.country_number}</td>
                    <td className="px-3 py-2">
                      <ActionButton props={region} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="px-3 py-3">...</td>
                  <td className="px-3 py-3">...</td>
                  <td className="px-3 py-3">...</td>
                  <td className="px-3 py-3">...</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

const ActionButton = ({ props }) => {
  const navigate = useNavigate();
  const { regions, deleteRegion, updateRegionState } =
    useContinentRegionContext();

  // Existing delete modal (kept, but fixed trigger)
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  // Generic confirm (Dashboard / Countries / Edit)
  const [confirm, setConfirm] = useState({
    open: false,
    title: "",
    message: "",
    onConfirm: null,
  });

  const continent_region_id = props?.continent_region_id;
  const continent_region_name = props?.name;
  const continent_region = props;

  const deleteOneRegion = async (region_id) => {
    const { status } = await deleteRegion(region_id);
    if (status === 200) {
      if (regions) {
        updateRegionState(
          regions.filter(
            (_region) => _region?.continent_region_id !== region_id
          )
        );
      }
      setShowDeleteModal(false);
    }
  };

  // Confirm wrappers (logic unchanged; just gated by a prompt)
  const onDashboard = () => {
    setConfirm({
      open: true,
      title: "Open Region Dashboard?",
      message:
        "You are about to navigate to this region’s dashboard. Continue?",
      onConfirm: () => {
        pushCurrentRegion(continent_region); // original
        navigate(singleRegionDash);
      },
    });
  };

  const onCountries = () => {
    setConfirm({
      open: true,
      title: "View Region Countries?",
      message:
        "You are about to open the countries view for this region. Continue?",
      onConfirm: () => {
        addOneRegion({
          id: continent_region_id,
          name: continent_region_name,
          route: "/region/manage",
          data: continent_region,
        }); // original
        pushRegion(continent_region); // original
        navigate(regionCountries);
      },
    });
  };

  const onEdit = () => {
    setConfirm({
      open: true,
      title: "Edit Region?",
      message:
        "You are about to open the edit form for this region. Continue?",
      onConfirm: () => {
        pushCurrentRegion(continent_region); // original
        navigate(editRegionRoute);
      },
    });
  };

  return (
    <>
      {/* Existing delete modal (fixed: now opens correctly) */}
      <Modal
        props={{
          name: continent_region_name,
          showModal: showDeleteModal,
          setShowModal: () => setShowDeleteModal(false),
          delete: () => deleteOneRegion(continent_region_id),
        }}
      />

      {/* New generic confirm dialog */}
      <ConfirmDialog
        open={confirm.open}
        title={confirm.title}
        message={confirm.message}
        onConfirm={confirm.onConfirm}
        onClose={() => setConfirm((s) => ({ ...s, open: false }))}
      />

      <div className="flex flex-wrap items-center justify-end gap-2 px-2 py-1">
        <MyButton
          title="Dashboard"
          className="bg-gray-900 hover:bg-gray-800 rounded-lg"
          onClick={onDashboard}
        />
        <MyButton
          title="Countries"
          className="bg-gray-900 hover:bg-gray-800 rounded-lg"
          onClick={onCountries}
        />
        <MyButton
          title="Edit"
          className="bg-blue-700 hover:bg-blue-600 rounded-lg"
          onClick={onEdit}
        />
        <MyButton
          title="Delete"
          className="bg-red-700 hover:bg-red-600 rounded-lg"
          onClick={() => setShowDeleteModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
